import { Component, OnInit } from "@angular/core";
import { LabKpiModel } from "src/app/shared/models/kpi.model";
import { AuthService } from "src/app/shared/services/auth.service";
import { LabKpiComponent } from "../lab-kpi.component";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-kpi-brosh",
  templateUrl: "./kpi-brosh.component.html",
  styleUrls: ["./kpi-brosh.component.scss"],
  standalone: true,
  imports: [LabKpiComponent, CommonModule],
})
export class KpiBroshComponent implements OnInit {
  get isAgent(): boolean {
    return this.authService.currentUser.roleCode == "AGENT";
  }

  get agentCode(): number {
    return this.authService.currentUser.agentCode;
  }

  constructor(private authService: AuthService) {}

  ngOnInit(): void {}
}
